var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('header-register',{attrs:{"showButtonView":false}},[_vm._v("DCB ")]),_c('formAddGeral')],1)}
var staticRenderFns = []

export { render, staticRenderFns }